Ext.define('SA.VectorMapLocationViewportRequests', {
    singleton: true,

    async get({geographicRelease, locationSeries, radius = 0}) {
        var isTemporal = locationSeries.every(locationSeries => SA.data.LocationsCache.isLocationAvailableInGeographicReleases(locationSeries, [geographicRelease])),
            getAttributeName = attribute => isTemporal ? `${attribute}->${geographicRelease}` : attribute,
            aggregates = [{locationSeries: ['in', 'locationSeries', ...locationSeries]}],
            select = [['with', radius > 0 ? ['extent', ['buffer', getAttributeName('polygon'), radius]] : getAttributeName('viewport'), 'viewport']],
            [{viewport}] = await SA.LocationSeriesRequests.get({aggregates, select});

        return SA.VectorMapExtent.fromXYBounds(viewport);
    }
});